/** @format */

import { NgModule } from "@angular/core";
import { Route, RouterModule } from "@angular/router";
import { HomeComponent } from "./components/home/home.component";
import { BodyComponent } from "./components/routings/body/body.component";
import { CalendarComponent } from "./components/routings/calendar/calendar.component";

const routes: Route[] = [
  {
    path: "",
    component: HomeComponent,
    children: [
      {
        path: "",
        component: BodyComponent,
        data: {
          showBackBtn: false
        }
      },
      {
        path: "calendar",
        component: CalendarComponent,
        data: {
          showBackBtn: true
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MisEmployeeWebExpRoutingModule {}
